module.exports = __webpack_public_path__ + "img/renga-logo.fa8c36c6.png";